/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import CardinalityEnum from './CardinalityEnum';
import ReferenceResolver from './ReferenceResolver';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // getModuleObject, superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityEnum (runtime) // new
//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveCardinalityType

/**
 * <p>Java class for cardinalityType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="cardinalityType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="mincard" type="{}cardinalityEnum" minOccurs="0"/&gt; &lt;element name="maxcard" type="{}cardinalityEnum" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class CardinalityType extends MoserObject{

	ref = null;

	mincard = null;

	maxcard = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(6, oldValue, value, false, false);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the mincard property.
	 * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	 */
	getMincard() {
		return this.mincard;
	}

	/**
	 * Sets the value of the mincard property.
	 * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	 */
	setMincard(value) {
		var oldValue = this.mincard;
		this.mincard = value;
		this._setAndNotify(235, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the maxcard property.
	 * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	 */
	getMaxcard() {
		return this.maxcard;
	}

	/**
	 * Sets the value of the maxcard property.
	 * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	 */
	setMaxcard(value) {
		var oldValue = this.maxcard;
		this.maxcard = value;
		this._setAndNotify(236, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>CardinalityType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> CardinalityType</code> object from.
	 * @return {CardinalityType} an object of type <code>CardinalityType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createCardinalityType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "CardinalityType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 6, "ref", null));
		featureList.push(this.createFeature(false, true, false, 235, "mincard", CardinalityEnum));
		featureList.push(this.createFeature(false, true, false, 236, "maxcard", CardinalityEnum));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 6:
			this.setRef((value));
			break;
		case 235:
			this.setMincard((value));
			break;
		case 236:
			this.setMaxcard((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		case 235:
			return this.getMincard();
		case 236:
			return this.getMaxcard();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		case 235:
			return this.getMincard();
		case 236:
			return this.getMaxcard();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		if (!this._referencedObject) {
			ReferenceResolver.resolveCardinalityType(this, MoserObject.getModuleObject(this));
		}
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/CardinalityType.js